import cookie from "js-cookie";

const getCookie = function (cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
};

const secure = process.env.NODE_ENV === "production" ? "secure" : "";
const cookieExpiryTime = () => new Date(new Date().getTime() + 45 * 60000);

export default {
	/**
	 * Create a cookie that stores the session JWT
	 * @param  {String} jwt The token we are saving
	 * @return {void}
	 */
	createLoginCookie: (jwt) => {
		// Create a cookie with our JWT
		document.cookie = `wonde-edu-login=${jwt};path=/;expires=${cookieExpiryTime().toUTCString()}; ${secure}`;
	},
	deleteLoginCookie: () => {
		document.cookie = `wonde-edu-login=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/; ${secure}`;
	},
	deleteAuthorizeCookie: () => {
		document.cookie = `wonde-authorize=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/; ${secure}`;
	},
	deleteSAMLCookie: () => {
		document.cookie = `wonde-saml=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/; ${secure}`;
	},
	deleteIntendedRouteCookie: () => {
		cookie.remove("wonde-intended-route");
	},
	doesLoginCookieExist: () => {
		return document.cookie.indexOf("wonde-edu-login") !== -1;
	},
	doesAuthorizeCookieExist: () => {
		return document.cookie.indexOf("wonde-authorize") !== -1;
	},
	doesIntendedRouteCookieExist: () => {
		return cookie.get("wonde-intended-route");
	},
	doesSAMLCookieExist: () => {
		return document.cookie.indexOf("wonde-saml") !== -1;
	},
	getSAMLCookie: () => {
		return JSON.parse(getCookie("wonde-saml"));
	},
	getIntendedRouteCookie: () => {
		return cookie.get("wonde-intended-route");
	},
	getAuthorizeCookie: () => {
		return JSON.parse(getCookie("wonde-authorize"));
	},
	getLoginCookie: () => {
		return getCookie("wonde-edu-login");
	},
	getOrgSchoolCookie: () => {
		return getCookie("organisation-school");
	},
	createIntendedRouteCookie: (path) => {
		cookie.set("wonde-intended-route", path, {
			expire: Date(new Date().getTime() + 10 * 60 * 1000),
		});
	},
	createSAMLCookie: (request, state) => {
		const content = JSON.stringify({
			request,
			state,
		});

		document.cookie = `wonde-saml=${content}; path=/; expires=${cookieExpiryTime().toUTCString()}; ${secure}`;
	},
	createAuthorizeCookie: (client_id, redirect_uri, company, state) => {
		const content = JSON.stringify({
			client_id,
			redirect_uri,
			company,
			state,
		});

		document.cookie = `wonde-authorize=${content}; path=/; expires=${cookieExpiryTime().toUTCString()}; ${secure}`;
	},
};



// WEBPACK FOOTER //
// ./src/components/libraries/cookie.js